// extracted by mini-css-extract-plugin
module.exports = {"addInvoiceForm":"styles_addInvoiceForm__LUwKj","buttonCancel":"styles_buttonCancel__2q1Mr","errorText":"styles_errorText__2SbKZ"};